import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Profile", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Personal Details", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "py-3" }, [
  /*#__PURE__*/_createTextVNode("Profile photo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_4 = { class: "flex flex-wrap justify-center" }
const _hoisted_5 = { class: "border-dashed border-2 border-light-gray-200 w-fit px-1 py-1 rounded-base" }
const _hoisted_6 = { class: "flex flex-col items-center space-y-3 pb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("(PNG/JPG)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("200 x 300 px")
], -1)
const _hoisted_8 = { class: "list-disc py-5 pl-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "workbean-idea" }),
  /*#__PURE__*/_createTextVNode(" Great profile photo tips")
], -1)
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "First name (Required)", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Last name (Required)", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Emailed displayed on Profile", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Gender", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Phone", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Birth date", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "City", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Country", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1)
const _hoisted_20 = { class: "sticky flex bottom-0 z-100 w-full p-2 bg-white shadow-md dark:bg-primary-black" }

import { arrowBackCircle, image } from "ionicons/icons"
  import { IonBackButton, IonButton } from "@ionic/vue"
  import { ref, computed, onMounted } from "vue"
  import { useUserStore } from "@/store/user"
  import { generateSchema } from "@/utils/validate"
  import { filter } from "lodash"
  import jwt from "@/utils/jwt"

  import CardTemplate from "@/components/template/CardTemplate.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import SelectTemplate from "@/components/template/SelectTemplate.vue"
  import PhoneTemplate from "@/components/template/PhoneTemplate.vue"
  import DatePicker from "@/components/template/DatePicker.vue"
  import FormTemplate from "@/components/template/formTemplate.vue"
  import UploadTemplate from "@/components/template/UploadTemplate.vue"
  import WbMultipleSelect from "@/components/template/ComboBoxContainer.vue"
  import LocationTemplate from "@/components/template/locationTemplate.vue"

  // initialize stores
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalContainer',
  setup(__props) {

  const userStore = useUserStore()

  // initilize resources
  const imageData = [
    "Your profile photo should show your face and with a smile on.",
    "Your profile should be all about you, so take a solo photo.",
    "Photo should be vertically oriented.",
    "Good image quality – no heavy filters, distortions, overlaid text, or watermarks.",
  ]
  const nbf = ref(jwt.generateNBF())
  const work_emails = computed(() => userStore.customerDetails.work_emails)
  const profile = computed<any>({
    get: () => userStore.customerDetails.profile,
    set: (val) => userStore.setCustomerDetails({ profile: val }),
  })
  const visibility = computed<any>(() => userStore.customerDetails.profile.visibility)
  const genderOption = [
    { name: "Male", value: "male" },
    { name: "Female", value: "female" },
    { name: "LGBTQA+", value: "non-binary" },
  ]
  const addressDetails = ref({
    country: "",
    city: "",
    full_address: "",
  })
  const isValidPhone = ref(true)

  // inputs
  const input = ref({
    photo: "",
    first_name: "",
    last_name: "",
    displayed_email: "",
    gender: "",
    phone_number: "",
    birthdate: "",
    city: "",
    country: "",
  })

  // initial values and schema
  const profileDetails = computed(() => ({
    photo: profile.value.photo,
    first_name: profile.value.name.first_name,
    last_name: profile.value.name.last_name,
    displayed_email: visibility.value?.includes("displayed_email") ? profile.value.displayed_email : "",
    gender: visibility.value?.includes("gender") ? profile.value.gender : "",
    phone_number: visibility.value?.includes("phone_number") ? profile.value.phone_number.default : "",
    birthdate: visibility.value?.includes("birthdate") ? profile.value.birthdate : "",
    city: profile.value.address.city,
    country: profile.value.address.country,
  }))
  const profileSchema = generateSchema([
    {
      name: "first_name",
      rule: "stringRequired",
    },
    {
      name: "last_name",
      rule: "stringRequired",
    },
    {
      name: "photo",
      rule: "stringRequired",
    },
    {
      name: "city",
      rule: "stringRequired",
    },
    {
      name: "country",
      rule: "stringRequired",
    },
  ])

  /**
   * set new location
   */
  const setLocation = (val: any) => {
    addressDetails.value = val
    input.value.city = val.city
    input.value.country = val.country
  }

  /**
   * handle phone validity
   */
  const validPhone = (valid: any) => {
    if (valid != null) isValidPhone.value = valid
  }

  /**
   * Saves profile details
   */
  const saveProfileDetails = () => {
    // list of visibility
    let visibilityList = visibility.value
    profile.value.photo = input.value.photo
    profile.value.name = {
      first_name: input.value.first_name,
      last_name: input.value.last_name,
      full_name: `${input.value.first_name} ${input.value.last_name}`,
    }
    profile.value.address = {
      city: input.value.city,
      country: input.value.country,
      full_address: addressDetails.value.full_address,
    }

    // set displayed_email visibility
    if (input.value.displayed_email.length) {
      profile.value.displayed_email = input.value.displayed_email
      if (!visibilityList?.includes("displayed_email")) visibilityList?.push("displayed_email")
    } else if (visibilityList?.includes("displayed_email")) {
      visibilityList = filter(visibilityList, (item) => item != "displayed_email")
    }

    // set gender visibility
    if (input.value.gender.length) {
      profile.value.gender = input.value.gender
      if (!visibilityList?.includes("gender")) visibilityList?.push("gender")
    } else if (visibilityList?.includes("gender")) {
      visibilityList = filter(visibilityList, (item) => item != "gender")
    }

    // set phone_number visibility
    if (input.value.phone_number.length) {
      profile.value.phone_number = { default: input.value.phone_number }
      if (!visibilityList?.includes("phone_number")) visibilityList?.push("phone_number")
    } else if (visibilityList?.includes("phone_number")) {
      visibilityList = filter(visibilityList, (item) => item != "phone_number")
    }

    // set birthdate visibility

    if (input.value.birthdate.length || (typeof input.value.birthdate == "object" && JSON.stringify(input.value.birthdate) != "null")) {
      if (typeof input.value.birthdate == "object") {
        const date = new Date(input.value.birthdate)
        profile.value.birthdate = date.toLocaleDateString()
      }
      if (!visibilityList?.includes("birthdate")) visibilityList?.push("birthdate")
    } else if (visibilityList?.includes("birthdate")) {
      visibilityList = filter(visibilityList, (item) => item != "birthdate")
    }

    // set details visibility
    profile.value.visibility = visibilityList

    // save details data to database
    const detailsData = {
      profile: {
        photo: profile.value.photo,
        name: profile.value.name,
        address: profile.value.address,
        displayed_email: profile.value.displayed_email,
        gender: profile.value.gender,
        phone_number: profile.value.phone_number,
        birthdate: profile.value.birthdate,
        visibility: profile.value.visibility,
      },
    }
    userStore.saveCustomerDetails(nbf.value, detailsData)
    userStore.retrieveProfileDetails("details")
  }

  /**
   * content initializations
   */
  onMounted(() => {
    userStore.retrieveProfileDetails("details")
    input.value = {
      ...input.value,
      ...profileDetails.value,
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonBackButton), {
                  class: "text-gray-300",
                  text: ``,
                  icon: _unref(arrowBackCircle)
                }, null, 8, ["icon"]),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(FormTemplate, {
          "validation-schema": _unref(profileSchema),
          "initial-values": JSON.parse(JSON.stringify(_unref(profileDetails))),
          class: "flex flex-col min-h-screen",
          onValid: saveProfileDetails
        }, {
          default: _withCtx(() => [
            _createVNode(CardTemplate, { class: "mx-4 my-6" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(UploadTemplate, {
                      id: 'profile_photo',
                      modelValue: input.value.photo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input.value.photo) = $event)),
                      name: "photo",
                      accepts: ".png, .jpg, .jpeg",
                      folder: "image",
                      type: "primary",
                      class: "h-[300px] w-[211px]"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_ion_icon, {
                            class: "text-3xl",
                            icon: _unref(image)
                          }, null, 8, ["icon"]),
                          _hoisted_7
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_8, [
                  _hoisted_9,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imageData, (list) => {
                    return _createElementVNode("li", {
                      key: `${list}_id`,
                      class: "ml-6 py-1"
                    }, _toDisplayString(list), 1)
                  }), 64))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(WbInput, {
                    modelValue: input.value.first_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input.value.first_name) = $event)),
                    name: "first_name",
                    type: "text",
                    placeholder: "Given name"
                  }, null, 8, ["modelValue"]),
                  _hoisted_12,
                  _createVNode(WbInput, {
                    modelValue: input.value.last_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((input.value.last_name) = $event)),
                    name: "last_name",
                    type: "text",
                    placeholder: "Family name"
                  }, null, 8, ["modelValue"]),
                  _hoisted_13,
                  _createVNode(WbMultipleSelect, {
                    modelValue: input.value.displayed_email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((input.value.displayed_email) = $event)),
                    name: "displayed_email",
                    data: _unref(work_emails),
                    type: "default",
                    "input-disabled": true,
                    "has-visibility": true,
                    placeholder: "Displayed Email"
                  }, null, 8, ["modelValue", "data"]),
                  _hoisted_14,
                  _createVNode(WbMultipleSelect, {
                    modelValue: input.value.gender,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((input.value.gender) = $event)),
                    name: "gender",
                    data: genderOption,
                    type: "default",
                    "display-selected-names": true,
                    "by-value": true,
                    "input-disabled": true,
                    "has-visibility": true,
                    placeholder: "Gender"
                  }, null, 8, ["modelValue"]),
                  _hoisted_15,
                  _createVNode(PhoneTemplate, {
                    modelValue: input.value.phone_number,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((input.value.phone_number) = $event)),
                    name: "phone_number",
                    placeholder: "Do not display",
                    onValidity: validPhone
                  }, null, 8, ["modelValue"]),
                  _hoisted_16,
                  _createVNode(DatePicker, {
                    modelValue: input.value.birthdate,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((input.value.birthdate) = $event)),
                    name: "birthdate",
                    format: "MM/dd/yyyy",
                    placeholder: "Do not display"
                  }, null, 8, ["modelValue"]),
                  _hoisted_17,
                  _createVNode(LocationTemplate, {
                    modelValue: input.value.city,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((input.value.city) = $event)),
                    name: "city",
                    placeholder: "City you currently live in",
                    "location-type": "city",
                    "floating-suggestions": false,
                    onLocation: setLocation
                  }, null, 8, ["modelValue"]),
                  _hoisted_18,
                  _createVNode(LocationTemplate, {
                    modelValue: input.value.country,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((input.value.country) = $event)),
                    name: "country",
                    placeholder: "Country you currently live in",
                    "location-type": "country",
                    "floating-suggestions": false,
                    onLocation: setLocation
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "white",
                type: "submit",
                "native-type": "submit",
                class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"])
      ]),
      _: 1
    })
  ], 64))
}
}

})